<p class="text-center">
    <i class="pi pi-envelope" style="font-size: 3rem"></i>
</p>
<h5 class="my-6 title-h5 text-center">{{ "public_register_finished_title" | translate }}</h5>
<p class="mt-6 mb-16 text-center">{{ "public_register_finished_text" | translate }}</p>
<p class="mt-12 mb-16 text-center page-text-light">
    {{ "public_register_finished_subtitle" | translate }}<br />
    {{ "public_register_finished_subtitle2" | translate }}
    <a class="text-blue-logo" href="{{ 'public_register_questions_link' | translate }}" target="_blank" rel="noopener">
        {{ "public_register_finished_contact" | translate }}
    </a>
</p>
